import React from "react";
import Button from "react-bootstrap/Button"
import TextTheme from "components/General/Text/TextTheme"

const BorderedButton = (props) => {
    return (
       <Button
          style = {{
              borderColor: props.borderColor,
              width: "100%"
          }}
          className={props.buttonClassName}
          size = "lg"
          onClick = {props.handleOnClick}
       >
          <b>
             <TextTheme  message = {props.title} className = {props.textClassName}/>
          </b>
       </Button>
    );
}
export default BorderedButton;